import {
    get,
    post
} from './request'
//轮播图
// 示例请求
export function GetSiteContentPageList(data) {
    return post('/JournalInfoApi/GetSiteContentPageList', data);
}

export function GetThatYearIssueList(data) {
    return get('/OldSiteWebApi/GetThatYearIssueList', data);
}

export function GetYearVolumeTree(data) {
    return get('/SiteWebApi/GetYearVolumeTree', data);
}

export function GetHomePageBlockInfo(data) {
    return post('/SiteWebApi/GetHomePageBlockInfo', data);
}
export function GetCurrentPeriod(data) {
    return get('/SiteWebApi/GetCurrentPeriod', data);
}
export function getYear(data) {
    return get('/JournalInfoApi/GetYearVolumeTree', data);
}
export function GetHistIssuePageList(data) {
    return post('/JournalInfoApi/GetHistIssuePageList', data);
}
export function GetContentInfo(data) {
    return post('/SiteWebApi/GetContentInfo', data);
}

export function GetBackIssueBrowsing(data) {
    return post('/SiteWebApi/GetBackIssueBrowsing', data);
}
export function GetAPPNavigationChild(data) {
    return get('/JournalInfoApi/GetAPPNavigationChild', data);
}
export function GetContentFilePath(data) {
    return get('/SiteWebApi/GetContentFilePath', data);
}
export function GetIssueSimpleSearch(data) {
    return post('/IssueContentApi/GetIssueSimpleSearch', data);
}
export function GetIssueMutiKeySearch(data) {
    return post('/IssueContentApi/GetIssueMutiKeySearch', data);
}

export function GetSiteSearch(data) {
    return post('/SiteWebApi/GetSiteSearch', data);
}

export function GetIssueinfoList(data) {
    return post('/JournalInfoApi/GetIssueinfoList', data);
}
// queryType=4/SiteWebApi/GetContentInfo
// journalId=那个数
// curr=1
// limit=条数 /api/SiteWebApi/GetYearVolumeTree

// Vue.prototype.$http = {
//     GetPageList
// }


